import { bufferToHex } from './helpers';
import { getKeyFromPem } from './pemExtractors';
export const encrypt = async (text, pubKey, hashAlgorithm = 'SHA-512')=>{
    const { subtle } = window.crypto;
    let pubCryptoKey;
    if (typeof pubKey === 'string') {
        // We import the key from PEM immediately with the specified hash algorithm parameter (default: SHA-512)
        pubCryptoKey = await getKeyFromPem(pubKey, null, hashAlgorithm);
    } else {
        // If a CryptoKey has already been passed (e.g. imported with a different hash),
        // we will export it and re-import it strictly under specified hash algorithm (default: SHA-512)
        try {
            const spkiBuffer = await subtle.exportKey('spki', pubKey);
            pubCryptoKey = await subtle.importKey('spki', spkiBuffer, {
                name: 'RSA-OAEP',
                hash: hashAlgorithm
            }, true, [
                'encrypt'
            ]);
        } catch (e) {
            // Default fallback if key was non-exportable
            pubCryptoKey = pubKey;
        }
    }
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const encryptedBuffer = await subtle.encrypt({
        name: 'RSA-OAEP'
    }, pubCryptoKey, data);
    return bufferToHex(encryptedBuffer);
};
